import { Component, Input, OnInit } from '@angular/core';
import { helpUrlsLookup } from 'go-modules/help-urls/help-urls.constant';
import type { LtiLmsNameMappings } from '@lti/app/types';
import { getUrlByLmsName } from '@lti/app/app-error/lms-instruction-urls';
import { ActiveBrandService } from '@go-modules/services/active-brand';

@Component({
	selector: 'default-error-renderer',
	templateUrl: './default-error-renderer.component.html',
	styleUrls: ['./default-error-renderer.component.scss'],
	standalone: false
})
export class DefaultErrorRendererComponent implements OnInit {
	@Input() public errors?: unknown | null;
	@Input() public lmsName: string;
	@Input() public mappings: LtiLmsNameMappings;

	public setupInstructionsLink: string;
	public contactSupport: string;

	public constructor (public activeBrandService: ActiveBrandService) {}

	public get translationParams () {
		return this.activeBrandService.getTranslationParams();
	}

	public ngOnInit (): void {
		this.contactSupport = helpUrlsLookup.contactSupport;
		this.setupInstructionsLink = getUrlByLmsName(this.lmsName, this.mappings);
	}
}
